import { useParams } from "react-router-dom";
import { useUserContext } from "../../user/contexts/user.context";
import { ParamsNames } from "../constantes/paramsNames";

/**
 * Hook pour obtenir le code organisation depuis l'URL ou le contexte utilisateur
 */
export const useOrganizationCode = (): string | null => {
  const params = useParams<{ [key: string]: string }>();
  const { getCurrentOrganization } = useUserContext();
  
  const organizationCodeFromUrl = params[ParamsNames.ORGANIZATION_CODE];
  
  if (organizationCodeFromUrl) {
    return organizationCodeFromUrl;
  }
  
  try {
    return getCurrentOrganization().code;
  } catch {
    return null;
  }
};

